import { motion } from "framer-motion";
import { GALLERY } from "../data";

export default function Gallery() {
  return (
    <main data-testid="gallery-page" className="pt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 lg:py-14">
        <span className="text-xs tracking-[0.25em] uppercase font-semibold text-[#A95C42]">
          Inspiration
        </span>
        <h1 className="font-serif-display text-5xl sm:text-6xl tracking-tight font-medium text-[#1E352F] mt-2">
          Gallery
        </h1>
        <p className="text-base text-[#4A5D54] mt-3 max-w-2xl leading-relaxed">
          Inspiration photos of what your property could look like.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 mt-8">
          {GALLERY.map((item, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group relative overflow-hidden rounded-sm border border-[#D1CFC7] aspect-[4/5]"
            >
              <img
                src={item.url}
                alt={item.caption}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </motion.figure>
          ))}
        </div>
      </div>
    </main>
  );
}
